





















import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class EventSetupCard extends Vue {
	@Prop({ required: true })
	public eventName!: string;

	@Prop({ required: false })
	public eventDescription!: string;

	@Prop({ required: false })
	public icon!: string;

	@Prop({ required: false })
	public iconColor!: string;

	@Prop({ required: true })
	public switchOn!: boolean;
}
